import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle, useUISize } from 'app/utils/web-helpers';
import { useEffect } from 'react';
import { LenderNextScreen as LenderNextScreenLarge } from './lender-next.large';
import { LenderNextScreen as LenderNextScreenSmall } from './lender-next.small';

const LenderNextScreenInner: NavigationScreen<'lenderNext'> = (props) => {
  const { isSmallUI } = useUISize();
  const setPageTitle = usePageTitle('lenderNext');
  useEffect(() => setPageTitle('headerTitle'), [setPageTitle]);

  if (isSmallUI) {
    return <LenderNextScreenSmall {...props} />;
  }
  return <LenderNextScreenLarge {...props} />;
};

export const LenderNextScreen = LenderNextScreenInner;
